import React from 'react';
import { TFunction } from 'client/i18n/hooks/useT';
import { Ad } from './types';
import {
  AmbassadorIcon,
  ListenerSupoortIcon,
  PremiumSponsorshipIcon,
  PodcastSubscriptionsIcon,
  SPANIcon,
  AdsByAnchorIcon,
} from '../Icons';

function AdsByAnchorSmallIcon({ id }: { id: string }) {
  return (
    <div style={{ width: '130px' }}>
      <AdsByAnchorIcon aria-hidden="true" id={id} />
    </div>
  );
}

export const PODCAST_AD_TYPES: Ad[] = [
  {
    adType: {
      getDescription: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsDescription',
          'All ads play across Spotify and other listening platforms where your podcast is distributed.',
          'Ads by Anchor page, Ambassador ads description'
        ),
      type: (
        <AdsByAnchorSmallIcon id="ads-by-anchor-icon-carousel-ambassador-ads" />
      ),
    },
    body: {
      getLanguage: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsBody',
          'Performance-based, host-read house ads spreading the word about Anchor to listeners.',
          'Ads by Anchor page, Ambassador ads description'
        ),
      svg: (screenType: string) => (
        <AmbassadorIcon aria-hidden={true} screen={screenType} />
      ),
    },
    stats: [
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsQualificationRequirement',
            '50 Listeners',
            'Ads by Anchor page, Ambassador ads qualification requirement'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.QualificationTitle',
            'Qualification',
            'Ads by Anchor page, ads type qualification title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdsReader',
            'Host',
            'Ads by Anchor page, who reads the ads'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdReaderTitle',
            'Who Reads the Ad',
            'Ads by Anchor page, ad reader title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsGetStarted',
            'Get started',
            'Ads by Anchor page, get started with Ambassador ads'
          ),
        link: '/dashboard/money',
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsGetStartedSubText',
            'Once you reach 50 listeners, click on the monetization tab.',
            'Ads by Anchor page, get started with Ambassador ads'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.HowToSignUp',
            'How to Sign Up',
            'Ads by Anchor page, how to sign up title'
          ),
      },
    ],
    getTitle: (t: TFunction) =>
      t(
        'AdsByAnchorScreen.Carousel.AdTypes.AmbassadorAdsTitle',
        'Ambassador ads',
        'Ads by Anchor page, Ambassador ads title'
      ),
  },
  {
    adType: {
      getDescription: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsDescription',
          'All ads play across Spotify and other listening platforms where your podcast is distributed.',
          'Ads by Anchor page, Automated ads description'
        ),
      type: (
        <AdsByAnchorSmallIcon id="ads-by-anchor-icon-carousel-automated-ads" />
      ),
    },
    body: {
      getLanguage: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsBody',
          'Tap into the Spotify Audience Network, and get access to ads from third-party brands, targeted to your listeners. Sponsor-read ads are automatically inserted in host-selected ad slots.',
          'Ads by Anchor page, Automated ads description'
        ),
      svg: (screenType: string) => (
        <SPANIcon aria-hidden={true} screen={screenType} />
      ),
    },
    stats: [
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsQualificationRequirement',
            'Any creator can apply',
            'Ads by Anchor page, Automated ads qualification requirement'
          ),
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsQualificationRequirementDescription',
            'Selection criteria includes: unique listeners, listening hours, Spotify followers, content that fits within Spotify ad guidelines.',
            'Ads by Anchor page, Automated ads qualification requirements'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.QualificationTitle',
            'Qualification',
            'Ads by Anchor page, ads type qualification title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsReader',
            'Sponsor',
            'Ads by Anchor page, who reads Automated ads'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdReaderTitle',
            'Who Reads the Ad',
            'Ads by Anchor page, ad reader title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsSignUpStatus',
            'Waitlist',
            'Ads by Anchor page, Automated ads sign up status'
          ),
        link: 'https://anch.co/automatedadssignup',
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsStatus',
            'In closed beta.',
            'Ads by Anchor page, Automated ads status'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.HowToSignUp',
            'How to Sign Up',
            'Ads by Anchor page, how to sign up title'
          ),
      },
    ],
    getTitle: (t: TFunction) =>
      t(
        'AdsByAnchorScreen.Carousel.AdTypes.AutomatedAdsTitle',
        'Automated ads',
        'Ads by Anchor page, Automated ads title'
      ),
  },
  {
    adType: {
      getDescription: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.PremiumSponsorshipsDescription',
          'All ads play across Spotify and other listening platforms where your podcast is distributed.',
          'Ads by Anchor page, Premium sponsorships description'
        ),
      type: (
        <AdsByAnchorSmallIcon id="ads-by-anchor-icon-carousel-premium-sponsorships-ads" />
      ),
    },
    body: {
      getLanguage: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.PremiumSponsorshipsBody',
          'Host-read ads for third-party brands. Available for creators with the highest listener engagement.',
          'Ads by Anchor page, Premium sponsorships description'
        ),
      svg: (screenType: string) => (
        <PremiumSponsorshipIcon aria-hidden={true} screen={screenType} />
      ),
    },
    stats: [
      {
        getBody: () => '—',
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.QualificationTitle',
            'Qualification',
            'Ads by Anchor page, ads type qualification title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdsReader',
            'Host',
            'Ads by Anchor page, who reads the ads'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdReaderTitle',
            'Who Reads the Ad',
            'Ads by Anchor page, ad reader title'
          ),
      },
      {
        getBody: () => '—',
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.PremiumSponsorshipsSignUpProcess',
            'An Anchor partner manager will reach out if you qualify for Premium sponsorships.',
            'Ads by Anchor page, Premium sponsorships sign up process'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.HowToSignUp',
            'How to Sign Up',
            'Ads by Anchor page, how to sign up title'
          ),
      },
    ],
    getTitle: (t: TFunction) =>
      t(
        'AdsByAnchorScreen.Carousel.AdTypes.PremiumSponsorshipsTitle',
        'Premium sponsorships',
        'Ads by Anchor page,Premium sponsorships description'
      ),
  },
  {
    adType: {
      getDescription: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.PodcastSubscriptionsDescription',
          'Set your price from a variety of options.',
          'Ads by Anchor page, podcast subscriptions description'
        ),
      type: (
        <>
          <span>Fan-supported:</span>
        </>
      ),
    },
    body: {
      getLanguage: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.PodcastSubscriptionsBody',
          'Monthly paid podcast subscriptions allowing listeners to support creators directly in return for bonus content and perks.',
          'Ads by Anchor page, podcast subscriptions description'
        ),
      svg: (screenType: string) => (
        <PodcastSubscriptionsIcon aria-hidden={true} screen={screenType} />
      ),
    },
    stats: [
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.NoMinimunListenersQualification',
            'No minimum listenership',
            'Ads by Anchor page, feature qualification requirement'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.QualificationTitle',
            'Qualification',
            'Ads by Anchor page, ads type qualification title'
          ),
      },
      {
        getBody: () => '—',
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdReaderTitle',
            'Who Reads the Ad',
            'Ads by Anchor page, ad reader title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.FeatureSetUpText',
            'Set up',
            'Ads by Anchor page, feature set up text'
          ),
        link: '/dashboard/money',
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.SetUpPodcastSubscriptionsMessage',
            'Set up your Podcast Subscription to get started.',
            'Ads by Anchor page, set up podcast subscriptions message'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.HowToSignUp',
            'How to Sign Up',
            'Ads by Anchor page, how to sign up title'
          ),
      },
    ],
    getTitle: (t: TFunction) =>
      t(
        'AdsByAnchorScreen.Carousel.AdTypes.PodcastSubscriptionsTitle',
        'Podcast Subscriptions',
        'Ads by Anchor page, podcast subscriptions description'
      ),
    learnMoreLink: 'https://anchor.fm/podcastsubscriptions',
  },
  {
    adType: {
      getDescription: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.ListenerSupportDescription',
          'The listener decides how much to give monthly.',
          'Ads by Anchor page, listener support description'
        ),
      type: (
        <>
          <span>Fan-supported:</span>
        </>
      ),
    },
    body: {
      getLanguage: (t: TFunction) =>
        t(
          'AdsByAnchorScreen.Carousel.AdTypes.ListenerSupportBody',
          'Allows creators’ most loyal listeners to support their favorite shows via monthly donation.',
          'Ads by Anchor page, listener support description'
        ),
      svg: (screenType: string) => (
        <ListenerSupoortIcon aria-hidden={true} screen={screenType} />
      ),
    },
    stats: [
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.NoMinimunListenersQualification',
            'No minimum listenership',
            'Ads by Anchor page, feature qualification requirement'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.QualificationTitle',
            'Qualification',
            'Ads by Anchor page, ads type qualification title'
          ),
      },
      {
        getBody: () => '—',
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.AdReaderTitle',
            'Who Reads the Ad',
            'Ads by Anchor page, ad reader title'
          ),
      },
      {
        getBody: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.FeatureSetUpText',
            'Set up',
            'Ads by Anchor page, feature set up text'
          ),
        link: '/dashboard/money',
        getSubtext: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.SetUpListenerSupportMessage',
            'Set up Listener Support via Anchor.',
            'Ads by Anchor page, set up listener support message'
          ),
        getTitle: (t: TFunction) =>
          t(
            'AdsByAnchorScreen.Carousel.AdTypes.HowToSignUp',
            'How to Sign Up',
            'Ads by Anchor page, how to sign up title'
          ),
      },
    ],
    getTitle: (t: TFunction) =>
      t(
        'AdsByAnchorScreen.Carousel.AdTypes.ListenerSupportTitle',
        'Listener Support',
        'Ads by Anchor page, listener support title'
      ),
  },
];
